<template>
  <v-card class="grey lighten-4">
    <v-card-title class="text-uppercase">
      Container {{ container.name }} <v-spacer />
      <client-form
        :key="container.name + storage.name"
        :container="container.name"
        :storage="storage.name"
      >
        <v-btn color="primary" dark>
          Add Client
        </v-btn>
      </client-form>
    </v-card-title>
    <v-card-subtitle>
      {{ container.azureName }}
    </v-card-subtitle>
    <v-card-text>
      <client-card
        v-for="client in clients"
        :key="client.clientId"
        :client="client"
        :storage="storage.name"
        :container="container.name"
      >
      </client-card>
    </v-card-text>
  </v-card>
</template>

<script>
import ClientForm from './ClientForm.vue'
import ClientCard from './ClientCard.vue'

export default {
  components: { ClientCard, ClientForm },
  name: 'ContainerList',
  props: {
    clients: {
      type: Array,
      required: true
    },
    container: {
      type: Object,
      required: true
    },
    storage: {
      type: Object,
      required: true
    }
  }
}
</script>

<style></style>
